import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { ROUTES } from './routes';

export const HomepageRoutes = () => {
  return (
    <Route exact path={`${ROUTES.HOMEPAGE.path}`}>
      <Redirect to={ROUTES.REGULATIONS_OVERVIEW.path} />
    </Route>
  );
};
